import { memo } from "react";
import InfoBar from "../../../../viewer/components/InfoBar";

const FreemiumAccessInfoBar = () => {
  return <InfoBar translation="freemiumViewerPreviewModeInformation" />;
};

export default memo(FreemiumAccessInfoBar);
